<template>
<div class="vliveHeader padding-20">
    <div class="vliveContent">
        <span>{{item.subject}}</span>
        <span>{{item.begintime}}</span>
        <!--<el-button class="btn" type="text" size="small" @click="handleEdit">修改</el-button>-->
        <!--<el-button class="btn" type="text" size="small" @click="handleDel">删除</el-button>-->
    </div>
    <!--<div class="pr-code-list">-->
        <!--<el-popover trigger="hover" placement="top" width="160">-->
            <!--<div class="vliveHeader-pr-code-upload padding-20">-->
                <!--<div class="pr-code-text">使用微信扫一扫</div>-->
                <!--<img :src="item.vlivePreUrl" alt="">-->
            <!--</div>-->
            <!--<el-button class="btn" type="text" size="small" slot="reference">-->
                <!--<span class="pr-code"><i class="icon icon_qr_code"></i>H5预览</span>-->
            <!--</el-button>-->
        <!--</el-popover>-->
        <!--<el-popover trigger="hover" placement="top" width="160">-->
            <!--<div class="vliveHeader-pr-code-upload padding-20">-->
                <!--<div class="pr-code-text">使用微信扫一扫</div>-->
                <!--<img :src="item.xcxQrCode" alt="">-->
            <!--</div>-->
            <!--<el-button class="btn" type="text" size="small" slot="reference">-->
                <!--<span class="pr-code"><i class="icon icon_qr_code"></i>小程序预览</span>-->
            <!--</el-button>-->
        <!--</el-popover>-->
    <!--</div>-->
</div>
</template>

<script>
import {getVliveInfoView} from 'api/api'
import {urlToQRCode} from 'common/js/tools'
import {mapActions} from 'vuex'
export default {
    name: 'vliveHeader',
    data() {
        return {
            item: {
                innerid: this.$route.query.id ? this.$route.query.id : '',
                begintime: '',
                subject: '',
                vlivePreUrl: ''
            }
        }
    },
    mounted() {
        this._getView()
    },
    methods: {
        handleEdit() {
            this.$router.push({name: 'VliveEdit', query: {id: this.item.id}})
        },
        handleDel () {
            this.$confirm('确定要删除直播吗？删除后所有链接里的视频都会失效，可恢复后再操作！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '成功!'
                })
            }).catch(() => {})
        },
        _getView() {
            this.setLoading(true)
            getVliveInfoView({
                data: {
                    innerid: this.item.innerid
                },
                success: data => {
                    this.item = data.data
                    this.item.vlivePreUrl = urlToQRCode(this.item.vlivePreUrl)
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
            this.item = {
                id: 1,
                title: '深圳职人圈 | 粤港澳斜杆大咖教你实现创业梦',
                date: '2019-05-18 14:00',
                wxQrCode: 'http://i2.sinaimg.cn/dy/c/2014-07-18/1405623657_VbFlfN.jpg',
                xcxQrCode: 'http://i2.sinaimg.cn/dy/c/2014-07-18/1405623657_VbFlfN.jpg'
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveHeader {
    @include flexBox(space-between);
    border-left: 4px solid $bgcolor-base;
    border-bottom: 1px solid $line;
    .vliveContent{
        span{
            margin-right: 30px;
        }
    }
    .pr-code-list{
        @include flexBox(space-between);
        .pr-code{
            margin-right: 40px;
            color: $tcolor-grey;
            font-size: $font-14;
            @include flexBox(space-between);
            .icon{
                width: 24px;
                height: 24px;
                margin-right: 12px;
            }
        }
    }
}
.el-popover{
    .vliveHeader-pr-code-upload{
        text-align: center;
        .pr-code-text{
            margin-bottom: 10px;
            color: $tcolor-base;
        }
        img{
            width: 120px;
            height: 125px;
        }
    }
}
</style>
